import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=7cf0b378&scoped=true&"
import script from "./PageContainer.vue?vue&type=script&lang=js&"
export * from "./PageContainer.vue?vue&type=script&lang=js&"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=7cf0b378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf0b378",
  null
  
)

export default component.exports